module.exports = __webpack_public_path__ + "img/logo-intl-express.32ae477.png";